<template>
  <div>
    <a-button id="add-new-group" type="link" class="button--add" @click="handleShowModal">
      <u>Agregar nuevo grupo</u>
    </a-button>
    <a-drawer
      :visible="visible"
      width="400px"
      centered
      rootClassName="add-new-group-drawer"
      :keyboard="false"
      :closable="false"
      @close="handleConfirmationClose"
    >
      <div class="container__title">
        <div>
          <span class="title__drawer">Agregar nuevo grupo</span>
          <a-tooltip>
            <template #title
              >Los grupos son un conjunto de resultados para que puedas asignarlos a una llamada o
              interacción. Los grupos contienen “Resultados”, y estos contienen “Motivos”.</template
            >
            <InfoCircleOutlined />
          </a-tooltip>
        </div>
        <CloseOutlined @click="handleCancel" />
      </div>
      <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
        <a-form-item label="Nombre del grupo" name="name">
          <a-input v-model:value="formState.name" placeholder="Escribir nombre del grupo" />
        </a-form-item>

        <a-form-item name="group_type" label="Tipo de grupo">
          <a-select
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            v-model:value="formState.group_type"
            placeholder="Seleccionar tipo de grupo"
          >
            <a-select-option v-for="groupType in groupTypes" :key="groupType.id">
              {{ groupType.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item name="code">
          <template #label>
            <span class="label">
              Código de integración
              <a-tooltip>
                <template v-slot:title>
                  Código de identificación para exportaciones o integraciones
                </template>
                <InfoCircleOutlined />
              </a-tooltip>
            </span>
          </template>
          <a-input v-model:value="formState.code" placeholder="Escribir código aquí..." />
        </a-form-item>
      </a-form>
      <typification-group-info />

      <fixed-footer
        confirmText="Agregar grupo"
        @onCancel="handleCancel"
        @onConfirm="handleOk"
        cancelText="Cancelar"
      />
    </a-drawer>
  </div>
</template>

<script>
import { InfoCircleOutlined, QuestionCircleOutlined, CloseOutlined } from "@ant-design/icons-vue";
import { defineComponent, reactive, ref, toRaw, createVNode } from "vue";
import TypificationGroupInfo from "@/app/entities/components/sections/TypificationGroupInfo.vue";
import FixedFooter from "@/app/shared/components/sections/FixedFooter.vue";
import { Modal } from "ant-design-vue";

export default defineComponent({
  components: {
    InfoCircleOutlined,
    TypificationGroupInfo,
    FixedFooter,
    CloseOutlined,
  },
  setup() {
    const formRef = ref();
    const formState = reactive({
      name: "",
      group_type: undefined,
      code: "",
    });
    const rules = {
      name: [{ required: true, message: "Campo requerido" }],
      group_type: [{ required: true, message: "Campo requerido" }],
    };
    return {
      formRef,
      formState,
      rules,
    };
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    groupTypes() {
      return this.$store.getters["getGroupTypes"];
    },
    typification() {
      return this.$store.getters["getTypificationTree"];
    },
  },
  methods: {
    handleOk() {
      this.formRef.validateFields().then(() => {
        const values = toRaw(this.formState);
        this.$emit("push", {
          ...values,
          status: 1,
          children: [],
          type: "group",
          is_expanded: true,
        });
        this.visible = false;
        this.formRef.resetFields();
      });
    },
    handleShowModal() {
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Estás seguro de descartar cambios?",
        content: "Al cerrar no se guardarán los datos previamente ingresados",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel(),
        centered: true,
        okText: "Descartar",
        cancelText: "Cancelar",
      });
    },
    FancyButton(slotContent) {
      return `<button class="fancy-btn">
      ${slotContent}
    </button>`;
    },
  },
});
</script>

<style lang="sass" scoped>
.ant-form
  margin-bottom: 30px
  margin-top: 20px

.title__drawer
  margin-right: 5px
  font-size: 16px
  font-weight: 600

.container__title
  height: 34px
  border-bottom: 1px solid #D4D4D4
  display: flex
  justify-content: space-between
</style>
